import { render, staticRenderFns } from "./SectionContainer.vue?vue&type=template&id=3aeb7dd9&"
import script from "./SectionContainer.vue?vue&type=script&lang=js&"
export * from "./SectionContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3aeb7dd9')) {
      api.createRecord('3aeb7dd9', component.options)
    } else {
      api.reload('3aeb7dd9', component.options)
    }
    module.hot.accept("./SectionContainer.vue?vue&type=template&id=3aeb7dd9&", function () {
      api.rerender('3aeb7dd9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-types/containers/SectionContainer.vue"
export default component.exports